exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntable {\n    table-layout: fixed;\n    border-spacing: 0px;\n    border-collapse: separate;\n}\n\nthead {\n    display: block;\n    overflow-x: hidden;\n    overflow-y: auto;\n}\n\ntbody {\n    display: block;\n    overflow-x: hidden;\n    overflow-y: auto;\n}\n\n.grid-container {\n    height: 100%;\n    width: 100%;\n    overflow-x: auto;\n}\n.odd {\n    background-color: aliceblue;  \n}\n\n.title {\n    height: 50px;\n    vertical-align: middle;\n}\n\n.in-selection {\n    border-color: darkgreen !important;\n    background-color: palegreen !important;\n}\n\n.current {\n    background-color: cadetblue;\n}\n\n.read-only {\n    background-color: lightyellow !important;\n}\n\n.padded {\n    padding-left: 5px;\n    padding-right: 5px;\n}\n\n.paging {\n    margin-top: -10px;\n}\n\n.filter {\n    z-index: 1;\n    width: 100%;\n    height: 30px;\n}\n\n.text-centre {\n    text-align: center;\n}\n\n.total-cell {\n    font-weight: bold;\n    border-top-width: 2px !important; \n    border-top-color: steelblue;\n}\n\n.no-entry {\n    font-family: \"Glyphicons Halflings\";\n    content:\"\\E090\";\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/Grid/grid.component.css
// module id = 446
// module chunks = 1